<script>
    import { db, auth } from './stores.js';
    export let status = "";

    //https://firebase.google.com/docs/auth/web/email-link-auth
    function signInWithEmail(email){
        const actionCodeSettings = {
            // url: 'http://localhost:5000/',
            // url: 'https://otech-dashboard.firebaseapp.com',
            url: window.location.href.toLowerCase(),
            handleCodeInApp: true,
        }

        $auth.sendSignInLinkToEmail(email, actionCodeSettings)
            .then(function() {
                window.localStorage.setItem('emailForSignIn', email);
                status = "Check your email for a link to log in."
            })
            .catch(function(signInError){
                status = signInError.code;
            });

    }

    async function checkIfAllowed(email){
        // Check to see if email is in approved list. If comes back empty, not allowed.
        const query =  await $db.collection("allowed").where("email","array-contains",email).get();
        return !query.empty;

    }
	async function handleSubmit(event){
        status = "";
        console.log('email: ', event.target.email.value);
        const isAllowed = await checkIfAllowed(event.target.email.value.toLowerCase());
        console.log('isAllowed: ', isAllowed);
        if(isAllowed){
            console.log('approved! Continue to authenticate!');
            signInWithEmail(event.target.email.value.toLowerCase());
        } else {
            status = "Sorry. Email not found in approved list."
        }

	}

</script>

<main>
    <div>
        <h1>Please sign in</h1>
        <form id="email-login" on:submit|preventDefault={handleSubmit}>
            <label for="email">Enter your email</label>
            <input type="email" id="email" required/>
            <button type="submit">submit</button>
        </form>
        <div id="status">{status}</div>
    </div>
</main>

<style>
    main {
        display:grid;
        place-items: center;
        height: 95vh;
        width: 100vw;
    }
</style>